import { FC } from 'react';
import { Preview, Print } from 'jbc-front/components/icons';
import ActionButton from 'jbc-front/components/ActionButton';

import { ReportName } from '@jbc-year-end-adj/2024/features/reports/employee/types';
import { REPORT_MAP } from '@jbc-year-end-adj/2024/features/reports/employee/consts';

import styles from './Report.scss';

type ReportType = {
  reportName: ReportName;
};

export const Report: FC<ReportType> = ({ reportName }) => {
  return (
    <>
      <div className={styles.icon}>
        <Preview size={16} />
      </div>
      <p className={styles.newLine}>{REPORT_MAP[reportName]}</p>
      <div className={styles.print}>
        <ActionButton primary icon={<Print size={15} />}>
          印刷
        </ActionButton>
      </div>
    </>
  );
};
